import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { skillsClient } from '#pplx_generated/typespec/rest/skills/client.js';
export async function getSkill(skillId, reason, viewScope = 'individual') {
    const { data, error, response } = await skillsClient.GET('/rest/skills/{skill_id}', reason, {
        params: {
            path: { skill_id: skillId },
            query: { view_scope: viewScope },
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch skill',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=getSkill.js.map